// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperTitle-cls1_Tnv","cls2":"PaperTitle-cls2_oUJ PaperTitle-cls1_Tnv"};